import React from "react";
// import '../../../App.css'

const Profile = () => {
  return (<>
    
  </>);
};

export default Profile;
